<template>
  <div ref="plotlyPlot" v-resize:debounce.100="onResize"></div>
</template>
<script>
  import Plotly from 'plotly.js-dist-min';

  const directives = {};
  if (typeof window !== "undefined") {
    directives.resize = require("vue-resize-directive");
  }

  export default {
    name: 'PlotlyWidget',
    directives,
    props: {
      series: Array,
      layout: Object,
      options: {
        type: Object,
        default() {
          return {
            responsive: true,
            editable: false,
            staticPlot: false,
            displayModeBar: false,
          };
        }
      }
    },
    data () {
      return {
        doReplot: false
      }
    },
    mounted() {
      this.renderChart();
    },
    methods: {
      onResize() {
        Plotly.Plots.resize(this.$refs.plotlyPlot);
      },
      renderChart() {
        Plotly.newPlot(this.$refs.plotlyPlot, this.series, this.layout, this.options);
      },
      replot() {
        if (!this.doReplot) {
          this.dReplot = true;
          this.$nextTick(() => {
            Plotly.react(this.$refs.plotlyPlot, this.series, this.layout, this.options);
            this.doReplot = false;
          });
        }
      }
    },
    watch: {
      series: {
        deep: true,
        handler() {
          this.replot();
        },
      },
      layout: {
        deep: true,
        handler() {
          this.replot();
        },
      },
      options: {
        deep: true,
        handler() {
          this.replot();
        },
      },
    },
    beforeDestroy() {
      Plotly.purge(this.$refs.plotlyPlot);
    }
  }
</script>



// WEBPACK FOOTER //
// PlotlyWidget.vue?786e4aed